// Centralized API route constants for repositories
export const API_ROUTES = {
  CHAT_COMPLETIONS: 'admin/chat/completions',
  COMPARE_MODELS: '/admin/chat/compare-models',
  MODEL_CONFIGS: 'admin/model-configs',
  MODEL_CONFIGS_ID: (id: string) => `admin/model-configs/${id}`,
  GLOBAL_SETTINGS: 'admin/globalsettings',
  CONFIG: 'admin/config',
  DEPLOYMENT_INSTANCES: 'admin/deployment-instances',
  DEPLOYMENT_INSTANCES_ID: (id: string) => `admin/deployment-instances/${id}`,
  DEPLOYMENTS_DELETE: (id: string, model_name: string) => `admin/deployments/delete/${id}/${model_name}`,
  DEPLOYMENTS_DEPLOY_INSTANCE: (id: string) => `admin/deployments/deploy-instance/${id}`,
  DEPLOYMENTS_SCALE_INSTANCE: (id: string) => `admin/deployments/scale-instance/${id}/1`,
  DEPLOYMENTS_STOP_INSTANCE: (id: string) => `admin/deployments/stop-instance/${id}`,
  DEPLOYMENTS_RESTART_INSTANCE: (id: string) => `admin/deployments/restart-instance/${id}`,
  DEPLOYMENT_INSTANCES_CONFIGS: (id: string) => `admin/deployment-instances-configs/${id}`,
  ROUTER_ADD_ROUTE: 'router/add-route',
  GET_ROUTER: 'router/routes',
  ROUTER_ROUTES: (instanceId: string) => `router/routes/${instanceId}`,
  GUARDRAILS: '/validators/',
  GUARDRAILS_APPLY: '/validators/apply',  
  GUARDRAILS_BY_ID: (id: string) => `/validators/${id}`,
  GUARDRAILS_DELETE: (id: string) => `/validators/${id}`,
  GUARDRAILS_DEPLOYED_INSTANCE: (instanceId: string) => `/validators/deployment/${instanceId}`,
  FINE_TUNE_UPLOAD_DATA: '/fine-tune/upload-data',
  FINE_TUNE_LIST_TRAINING_FILES: (instanceId: string) => `/fine-tune/list-training-files/${instanceId}`,
  FINE_TUNE_JOBS: (namespace: string) => `/fine-tune/jobs?namespace=${namespace}`,
  FINE_TUNE_START: '/fine-tune/start',
  FINE_TUNE_DEPLOY: '/fine-tune/deploy',
  FINE_TUNE_CREATE_MODEL_CONFIG: '/fine-tune/create/model/config',
  RAG_UPLOAD_CSV: '/graph-rag/api/upload-csv-direct',
  RAG_UPLOAD_PDF: '/pvc/files/upload',
  RAG_LIST_FILES: '/pvc/files/list',
  RAG_DELETE_FILES: '/pvc/files/delete',
  RAG_DOWNLOAD_FILE: (filename: string) => `/pvc/files/download/${filename}`,
  RAG_INGEST_FROM_PVC: '/rag/knowledge-base/ingest/from-pvc',
  RAG_INGEST_EVENTS: (jobId: string) => `/rag/knowledge-base/events/ingest/${jobId}`,
  RAG_INGEST_HISTORY: '/rag/knowledge-base/ingest/history',
  
  // Metrics APIs
  METRICS_REQUESTS_OVER_TIME: (timeRange: string) => `admin/metrics/requests?range=${timeRange}`,
  METRICS_ERROR_RATE: (timeRange: string) => `v1/request-logs/analytics/error-rate?range=${timeRange}`,
  METRICS_SUMMARY: (timeRange: string) => `admin/metrics/summary?range=${timeRange}`,
  METRICS_TOKENS: (timeRange: string) => `admin/metrics/tokens?range=${timeRange}`,

  // Prompt Lab APIs
  USAGE_TYPES: 'admin/usage-types',
  PROMPT_VARIABLES: 'orchestration/prompt-variables',
  PROMPTS: 'admin/prompts',

  // Evaluation APIs
  DATASETS: 'evaluation/datasets',
  DATASETS_BY_ID: (id: string) => `evaluation/datasets/${id}`,
  DATASET_TEMPLATE: (type: string) => `evaluation/dataset/${type}`,
  EVAL_METRICS: 'evaluation/metrics',
  EVAL_CREATE: 'evaluation/',
  EVAL_LIST: 'evaluation/',
  EVAL_BY_ID: (id: string) => `evaluation/${id}`,
  EVAL_MODELS: (id: string) => `evaluation/${id}/models`,
  EVAL_MODEL_VERSIONS: (evaluationId: string, deploymentId: string) => `evaluation/${evaluationId}/models/${deploymentId}/versions`,
  EVAL_RUN_RESULTS: (runId: string) => `evaluation/evaluation-runs/${runId}/results`,

};
